var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"layout\"><formly-form model=\"vm.resource\" fields=\"vm.fields\"></formly-form></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/segments/segmentsForm.jade
 ** module id = 853
 ** module chunks = 0
 **/